var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{style:(`height: ${_vm.height}px; width: 100%;`),attrs:{"option":_vm.options,"init-options":{renderer: 'svg'},"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }